<template>
  <div class="role">
    <div class="text-2xl font-bold mb-6">Role Management</div>
    <div class="flex justify-center w-3/5 items-center gap-2 text-primary-500 ">
      <div
        class="flex-1 text-center border border-primary-500 border-b-0 py-2 rounded-t-lg block transition-all cursor-pointer"
        v-for="(role, index) in roleList"
        :key="index"
        @click="selectTab(role)"
        :class="{ 'bg-primary-500 text-white font-medium': role.isActive }"
      >
        {{ role.title }}
      </div>
    </div>
    <div class="border p-6 border-primary-500 rounded-b-md rounded-r-md shadow-lg">
      <div class="flex gap-6 items-start justify-between">
        <div class="flex gap-6 items-start">
          <p>Please select the role:</p>
          <div class="w-52">
            <v-select :options="selectedGroupRole" v-model="selectedRole"></v-select>
          </div>
          <p>Or</p>
          <div>
            <Button buttonText="Add New Role" type="secondary" @action="toggleField()" />
          </div>
        </div>
        <Button buttonText="Save" />
      </div>
      <div class="text-center mt-10">
        <p class="text-xl font-bold mb-10">Permission Settings</p>
        <div class="mb-10" v-for="(group, index) in permissionList" :key="`group-${index}`">
          <div class="bg-neutral-600 text-white text-left text-base px-4 py-3 mb-6 rounded-md">{{ group.groupTitle }}</div>
          <div class="w-3/5 pl-6">
            <table class="border-collapse w-full table-fixed text-left">
              <thead>
                <tr>
                  <td class="border py-2 px-4 bg-system-gray text-center">Permission Fuction</td>
                  <td class="border py-2 px-4 bg-system-gray text-center">&nbsp;</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in group.list" :key="item.id">
                  <td class="border py-2 px-4">{{ item.title }}</td>
                  <td class="border py-2 px-4 text-center align-middle leading-0">
                    <label class="relative inline-block h-4 leading-0">
                      <input
                        type="checkbox"
                        class="w-10 h-4 transition bg-gray-300 rounded-full shadow-inner outline-none appearance-none checked:bg-blue-500 disabled:bg-gray-100"
                        v-model="permissionModel[item.id]"
                      />
                      <span class="absolute top-0 left-0 w-4 h-4 transition-all transform scale-150 bg-system-gray rounded-full shadow-sm cursor-pointer"></span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Modal :show="visibleField" @close="closeModal()">
      <template slot="header"><p class="text-xl font-bold text-center">Add New Role</p></template>
      <template slot="body">
        <div class="flex gap-4 mt-6 items-center justify-center">
          <div class="w-3/5">
            <TextField type="text" placeholder="Role name" v-model="newRole" />
          </div>
          <div>
            <Button buttonText="Add" type="primary" @action="addRole()" />
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { role, permission } from '@/constants'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
export default {
  components: {
    'v-select': vSelect,
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    Modal: () => import(/* webpackChunkName: "Modal" */ '@/components/Modal/Modal')
  },
  data: () => ({
    roleList: role,
    permissionList: permission,
    selectedGroupRole: [],
    selectedRole: '',
    permissionModel: {
      'order_management.create_order': false,
      'order_management.view_order': false,
      'order_management.list_order': false,
      'awb_tracking.track_linknau_awb': false,
      'awb_tracking.track_partner_awb': false,
      'partner_management.add_new_partner': false,
      'partner_management.update_partner_info': false,
      'partner_management.delete_partner': false,
      'partner_management.deactivate_partner': false,
      'partner_management.activate_partner': false,
      'partner_management.revoke_api_key': false,
      'partner_management.generate_api_key': false,
      'partner_management.view_partner': false,
      'partner_management.list_partner': false,
      'role_management.view_list': false,
      'role_management.view_detail': false,
      'role_management.create': false,
      'role_management.update': false,
      'role_management.delete': false,
      'partner_user_management.view_list ': false,
      'partner_user_management.view_detail': false,
      'partner_user_management.create': false,
      'partner_user_management.update': false,
      'partner_user_management.delete': false,
      'partner_user_management.revoke_session': false,
      'partner_user_management.list_session': false,
      'partner_user_management.change_password': false,
      'partner_user_management.set_active_status': false,
      'partner_user_management.verify_account': false,
      'partner_driver_management.view_list ': false,
      'partner_driver_management.view_detail': false,
      'partner_driver_management.create': false,
      'partner_driver_management.update': false,
      'partner_driver_management.delete': false,
      'partner_driver_management.revoke_session': false,
      'partner_driver_management.list_session': false,
      'partner_driver_management.suspend': false,
      'partner_driver_management.release_suspension': false,
      'partner_driver_management.change_password': false,
      'partner_driver_management.set_active_status': false,
      'partner_driver_management.verify_account': false,
      'partner_dropoff_agent_management.view_list ': false,
      'partner_dropoff_agent_management.view_detail': false,
      'partner_dropoff_agent_management.create': false,
      'partner_dropoff_agent_management.update': false,
      'partner_dropoff_agent_management.delete': false,
      'delivery_cost_mapping.view_list ': false,
      'delivery_cost_mapping.view_detail': false,
      'delivery_cost_mapping.create': false,
      'delivery_cost_mapping.update': false,
      'delivery_cost_mapping.delete': false,
      'delivery_package_management.view_list': false,
      'delivery_package_management.view_detail': false,
      'delivery_package_management.create': false,
      'delivery_package_management.update': false,
      'delivery_package_management.delete': false,
      'delivery_package_management.set_active_status': false,
      'master_data_city.view_list ': false,
      'master_data_city.view_detail': false,
      'master_data_city.create': false,
      'master_data_city.update': false,
      'master_data_city.delete': false,
      'master_data_payment_methods.view_list ': false,
      'master_data_payment_methods.view_detail': false,
      'master_data_payment_methods.create': false,
      'master_data_payment_methods.update': false,
      'master_data_payment_methods.delete': false,
      'master_data_goods_category.view_list ': false,
      'master_data_goods_category.view_detail': false,
      'master_data_goods_category.create': false,
      'master_data_goods_category.update': false,
      'master_data_goods_category.delete': false,
      'master_data_permissions.list': false,
      'pertashop_local_agent.view_list ': false,
      'pertashop_local_agent.view_detail': false,
      'pertashop_local_agent.create': false,
      'pertashop_local_agent.update': false,
      'pertashop_local_agent.delete': false
    },
    visibleField: false,
    newRole: ''
  }),
  mounted() {
    this.selectTab(this.roleList[0])
  },
  methods: {
    selectTab(tab) {
      this.selectedRole = ''
      this.selectedGroupRole = tab.roles
      this.roleList.forEach(item => {
        item.isActive = false
      })
      tab.isActive = true
    },
    toggleField() {
      this.visibleField = !this.visibleField
    },
    addRole() {
      this.selectedGroupRole.push(this.newRole)
      this.toggleField()
    }
  }
}
</script>
<style lang="scss" scoped>
input:checked[type='checkbox'] + span {
  left: 1.5rem;
  top: 0;
  background-color: #f2994a;
}
input:checked[type='checkbox']:disabled {
  background-color: rgba(25, 21, 255, 0.5);
}
input:checked[type='checkbox']:disabled + span {
  background-color: rgb(93, 91, 233);
  box-shadow: none;
}
input[type='checkbox']:disabled + span {
  background-color: rgb(214, 211, 211);
  box-shadow: none;
}
</style>
